import * as Styled from "./style";
import { UserMenus } from "~/components/blocks/layout/global-navi/common/user-menu";

export type UserMenuBlockProps = {
  onHideUserMenu: () => void;
};

export const UserMenuBlock = ({ onHideUserMenu }: UserMenuBlockProps) => {
  return (
    <Styled.DivUserMenuContainer>
      <UserMenus onHideUserMenu={onHideUserMenu} />
    </Styled.DivUserMenuContainer>
  );
};
